import { BrowserRouter, Routes, Route } from "react-router-dom";
import Topbar from "./components/topbar/Topbar";
import Menu from "./components/menu/Menu";
import Home from "./components/home/Home";
import MyPortfolio from "./components/my-portfolio/MyPortfolio";
import "./app.scss"
import { useState } from "react";


function App() {

  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <BrowserRouter>
      <div className="app">
        <Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}></Topbar>
        <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen}></Menu>
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/my-portfolio" element={<MyPortfolio />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
